import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Api } from "../api.config";
import { QueryKeys } from "../LinkGen";

export const useXAdminCheck = () => {
	return useQuery({
		queryKey: QueryKeys.Integrations.X.AdminCheck(),
		queryFn: () => Api.GetXAdminCheck().then((r) => r.data),
		staleTime: 5 * 60 * 1000,
	});
};

export const useXAdminSpend = (
	enabled: boolean,
	year: number,
	month: number,
) => {
	return useQuery({
		queryKey: QueryKeys.Integrations.X.AdminSpend(year, month),
		queryFn: () => Api.GetXAdminSpend(year, month).then((r) => r.data),
		enabled,
	});
};

export const useSetXPublishingEnabled = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (enabled: boolean) =>
			Api.SetXPublishingEnabled(enabled).then((r) => r.data),
		onSuccess: () => {
			void queryClient.invalidateQueries({
				queryKey: ["INTEGRATIONS", "X", "ADMIN_SPEND"],
			});
			void queryClient.invalidateQueries({
				queryKey: QueryKeys.AppMetadata(),
			});
		},
	});
};
